import CardCompanyHorizontal from "./card-company-horizontal";

export default CardCompanyHorizontal;